module.exports = __webpack_public_path__ + "static/media/practice-question-header.5b139fc2.png";